var $5cd99c404e06eb9f$exports = {};
$5cd99c404e06eb9f$exports = {
  "backButton": args => "Tagasi ".concat(args.prevMenuButton),
  "moreActions": "Veel toiminguid",
  "unavailable": "Pole k\xE4ttesaadav, \xFCksikasjade vaatamiseks laiendage"
};
export { $5cd99c404e06eb9f$exports as default };